import { useContext } from 'react'

import { uniq } from 'ramda'

import { MOC_ONBOARDING_FLOW } from 'app-constants'
import { PlaidLinkExitError, sendToSentry } from 'utils/errors'
import { FunnelContext } from 'utils/FunnelContext'

import { FunnelName, LinkedSubaccount, LinkedSubaccountRoleEnum } from '../../../generated/types'

type PlaidError = {
  display_message: string
  error_type: string
  error_code: string
  error_message: string
}

const BlacklistedErrorCodes = [
  'INVALID_CREDENTIALS',
  'INVALID_MFA',
  'NO_ACCOUNTS',
  'USER_SETUP_REQUIRED',
]

export const getAvailableFundingSources = (linkedSubaccounts: LinkedSubaccount[]) => {
  let results = linkedSubaccounts.filter(({ allowedRoles }) =>
    allowedRoles.includes(LinkedSubaccountRoleEnum.PrimaryFunding),
  )

  results = results.concat(
    linkedSubaccounts.filter(({ role }) => role === LinkedSubaccountRoleEnum.PrimaryFunding),
  )

  return uniq(results)
}

export const processOnPlaidExitError = (error: PlaidError) => {
  if (!BlacklistedErrorCodes.includes(error.error_code)) {
    sendToSentry(new PlaidLinkExitError(error.display_message), { extras: error })
  }
}

export const useFundingSkipLinkText = (flow: string) => {
  const { isDynamicFunnelEnabled, metadata } = useContext(FunnelContext)
  const isMOCOnboardingFlow =
    (isDynamicFunnelEnabled && metadata.name === FunnelName.MightyOakCard) ||
    flow === MOC_ONBOARDING_FLOW
  let skipLinkText = 'Skip'
  if (isMOCOnboardingFlow) {
    skipLinkText = null
  }

  return skipLinkText
}
